$(document).ready(function () {
  $(".cartUpsellContainer .cartUpsellProdBox-2").flickity({
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
  });
});

// Account and Profile page
$(".sideProfileBtn").click(function () {
  $(".sideProfileBtn").removeClass("active");
  $(this).addClass("active");
  var activeTabId = $(this).attr("data-tabid");
  $(".tabContentInner").hide();
  $(activeTabId).fadeIn(300);
});

$(".sideProfileBtn-m").click(function () {
  var activeTabId = $(this).attr("data-tabid");
  $(".tabContentInner").hide();
  $(activeTabId).fadeIn(300);
  $(this).parent().hide();
  $(".account-back-btn").show();
});

if (window.innerWidth <= 798) {
  $(".account-back-btn").click(function () {
    $(".profileSideNav.is-hidden-desktop-only").show();
    $(".tabContentInner").hide();
    $(this).hide();
  });
}

$(".showNewAddressForm").click(function () {
  $(this).hide();
  $("#add_address").slideDown();
});

$(".cancelAddressForm").click(function () {
  $(".showNewAddressForm").show();
  $("#add_address").slideUp();
});

$(window).on("resize", function () {
  var windowWidth = $(window).width();

  if (windowWidth < 799) {
    $(".block__link-list .footer__heading")
      .off("click")
      .on("click", function () {
        var $Content = $(this).next(".block__link-list ul");
        if ($(this).parent().hasClass("footer--active")) {
          $(this).parent().removeClass("footer--active");
          $Content.slideUp();
        } else {
          $(".block__link-list ul").slideUp();
          $(".block__link-list .footer__menu").removeClass("footer--active");
          $(this).parent().addClass("footer--active");
          $Content.slideDown();
        }
      });

    $("aside.sidebar-section").insertAfter(".collection__filters .main-filter p");
    $(".sorting-filter-text .collection__sort-by-filter").appendTo(".collection__filters .sorting-filter");

    $('.sort_by').attr('data-default-sort', 'sort-by');
    
    $('.sort_by option[value="default"]').each(function() {
      $(this).val('sort-by');
      $(this).text('Sort By');
    });
  } else {
    $(".block__link-list .footer__heading").off("click");
  }
});
$(window).trigger("resize");

$(document).ready(function () {
  $("li.back-btn").click(function () {
    $("#mobile-submenu-2").trigger("click");
  });
});

$(document).ready(function () {
  $(".mobile-header .mega-menu__content .menu__heading").click(function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next("ul").slideUp();
    } else {
      $(".mobile-header .mega-menu__content ul").slideUp();
      $(".mega-menu__content .menu__heading").removeClass("active");
      $(this).addClass("active");
      $(this).next("ul").slideDown();
    }
  });
});

$(document).ready(function () {
  $(".mobile-filter-column .main-filter p").click(function () {
    $(this).parent().toggleClass("active-filter");
    $(this).next(".mobile-filter-column aside.sidebar-section").slideToggle();
  });
});

$(document).ready(function () {
  function checkAndAddClass() {
    $(".upsellInnerContainer").each(function () {
      var containerId = $(this).attr("id");
      var matchingProduct = false;

      $(".ajax-cart__list .ajax-cart__product").each(function () {
        var prodId = $(this).data("prod-id");
        if (containerId == prodId) {
          matchingProduct = true;
          return false;
        }
      });

      if (matchingProduct) {
        $(this).addClass("FadedProd");
      } else {
        $(this).removeClass("FadedProd");
      }
    });
  }

  checkAndAddClass();

  setInterval(checkAndAddClass, 3000);
});

$(document).ready(function() {
  var subTotalSection = $('.ajax-cart__details-wrapper').innerHeight();
  var upSellSection = $('.cartUpsellContainer');
  $(upSellSection).css('bottom', subTotalSection + 'px');
});


$(document).ready(function() {
  $('.schedule-a-call .caption-content .buttons a:nth-child(1)').click(function(e) {
    e.preventDefault(); 
    $('html, body').animate({
      scrollTop: $('.initial-consult').offset().top - 130 
    }, 800); 
  });

  $('.schedule-a-call .caption-content .buttons a:nth-child(2)').click(function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('.follow-up-call').offset().top - 130
    }, 800); 
  });
});

// Sample Product Script
$(document).ready(function() {
    const sampleProductId = '9576189100191'; 

    function updateCartPrices() {
        $.ajax({
            url: '/cart.js',
            method: 'GET',
            dataType: 'json',
            success: function(cart) {
                cart.items.forEach(function(item) {
                    const $productTotal = $(`[data-product-id="${item.product_id}"] .cart__total .money`);
                    if ($productTotal.length) {
                        $productTotal.text(Shopify.formatMoney(item.final_line_price));
                    }
                });
                $('.cart__subtotal__price .money').text(Shopify.formatMoney(cart.total_price));
                toggleCheckoutButton(cart);
            },
            error: function(xhr, status, error) {
                console.error('Error fetching cart data:', error);
            }
        });
    }

    function enforceSampleProductQuantity() {
        $('.cart__card').each(function() {
            const $cartItem = $(this);
            const productId = $cartItem.data('product-id');
            const $quantityInput = $cartItem.find('.cart__quantity input');
            let currentQuantity = parseInt($quantityInput.val());

            if (productId == sampleProductId && currentQuantity > 2) {
                currentQuantity = 2;
                $quantityInput.val(currentQuantity);
                const lineItemKey = $cartItem.data('cart-item');
                if (!lineItemKey) {
                    console.error('Line item key not found for enforcing sample product quantity.');
                    return;
                }
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: {
                        id: lineItemKey,
                        quantity: currentQuantity
                    },
                    dataType: 'json',
                    success: function() {
                        updateCartPrices(); 
                    },
                    error: function(xhr, status, error) {
                        console.error('Error updating cart quantity:', error);
                        console.error('Data sent:', {
                            id: lineItemKey,
                            quantity: currentQuantity
                        });
                    }
                });
            }
        });
    }

    function toggleCheckoutButton(cart) {
        let containsOnlySample = true;
        let containsSample = false;
        cart.items.forEach(function(item) {
            if (item.product_id == sampleProductId) {
                containsSample = true;
            } else {
                containsOnlySample = false;
            }
        });

        if (containsSample && containsOnlySample) {
            $('.cart__checkout #checkout').prop('disabled', true);
            $('.sample-product-notice').removeClass('is-hidden');
            if ($('.cart__checkout #checkout-tooltip').length === 0) {
                $('.cart__checkout').append('<div id="checkout-tooltip" class="checkout-tooltip" style="display: none;">You cannot purchase only the sample product.</div>');
            }
        } else {
            $('.cart__checkout #checkout').prop('disabled', false);
            $('.sample-product-notice').addClass('is-hidden');
            $('#checkout-tooltip').remove();
        }
    }

    $(document).on('mouseenter', '#checkout[disabled]', function() {
        $('#checkout-tooltip').fadeIn();
    }).on('mouseleave', '#checkout[disabled]', function() {
        $('#checkout-tooltip').fadeOut();
    });

    function initializeCart() {
        $.ajax({
            url: '/cart.js',
            method: 'GET',
            dataType: 'json',
            success: function(cart) {
                toggleCheckoutButton(cart);
            },
            error: function(xhr, status, error) {
                console.error('Error fetching cart data:', error);
            }
        });
    }

    $(document).on('change input', '.cart__quantity input', function() {
        const $quantityBox = $(this);
        const lineItemKey = $quantityBox.closest('.cart__card').data('cart-item');
        const productId = $quantityBox.closest('.cart__card').data('product-id');
        let newQuantity = parseInt($quantityBox.val());

        if (!lineItemKey) {
            console.error('Line item key not found on quantity input change.');
            return;
        }

        if (productId == sampleProductId && newQuantity > 2) {
            newQuantity = 2;
            $quantityBox.val(newQuantity);
            showQuantityWarning($quantityBox);
        }

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: lineItemKey,
                quantity: newQuantity
            },
            dataType: 'json',
            success: function() {
                updateCartPrices();
            },
            error: function(xhr, status, error) {
                console.error('Error updating cart quantity:', error);
                console.error('Data sent:', {
                    id: lineItemKey,
                    quantity: newQuantity
                });
            }
        });
    });

    $(document).on('click', '.quantity-minus, .quantity-plus', function() {
        const $quantityBox = $(this).siblings('.control').find('input.quantity-input');
        const $cartItem = $quantityBox.closest('.cart__card');
        const lineItemKey = $cartItem.data('cart-item');
        const productId = $cartItem.data('product-id');
        let newQuantity = parseInt($quantityBox.val());

        if (!lineItemKey) {
            console.error('Line item key not found on plus/minus button click.');
            return;
        }

        if (productId == sampleProductId && newQuantity >= 2) {
            newQuantity = 2;
            $quantityBox.val(newQuantity);
            showQuantityWarning($quantityBox);
        }

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: lineItemKey,
                quantity: newQuantity
            },
            dataType: 'json',
            success: function() {
              updateCartPrices();
              enforceSampleProductQuantity();
            },
            error: function(xhr, status, error) {
                console.error('Error updating cart quantity:', error);
                console.error('Data sent:', {
                    id: lineItemKey,
                    quantity: newQuantity
                });
            }
        });
    });

    $(document).on('click', '.ajax-cart__delete', function(e) {
        e.preventDefault();
        const lineItemKey = $(this).data('cart-item-key');

        if (!lineItemKey) {
            console.error('Line item key not found on item removal.');
            return;
        }

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: lineItemKey,
                quantity: 0
            },
            dataType: 'json',
            success: function() {
                updateCartPrices();
                initializeCart();
            },
            error: function(xhr, status, error) {
                console.error('Error removing item from cart:', error);
                console.error('Data sent:', {
                    id: lineItemKey,
                    quantity: 0
                });
                initializeCart();
            }
        });
    });

    function showQuantityWarning($quantityBox) {
        const $warningElement = $quantityBox.closest('.cart__quantity').find('.cart__quantity-warning');
        $warningElement.text('Maximum limit reached.').show();
        setTimeout(function() {
            $warningElement.text('');
        }, 6000);
    }

    enforceSampleProductQuantity();
    initializeCart();

    $(document).on('click', '.ajax-cart__quantity-box .quantity-plus', function() {
        const $quantityBox = $(this).siblings('.control').find('input.quantity-input');
        const $cartItem = $(this).closest('.ajax-cart__product');
        const productId = $cartItem.data('prod-id');
        let newQuantity = parseInt($quantityBox.val());
    
        if (productId == sampleProductId && newQuantity >= 2) {
            newQuantity = 2;
            $quantityBox.val(newQuantity);
            $cartItem.find('.ajax-cart__quantity-warning').text('Maximum limit reached').show();
            setTimeout(function() {
                $cartItem.find('.ajax-cart__quantity-warning').text('');
            }, 6000);
        }
    });

});





